import { S as Swiper, E as EffectFade } from "@theme/effect-fade";
import { P as Pagination } from "@theme/pagination";
class ImageSliderComponent extends window.HTMLElement {
  constructor() {
    super();
    this.DOM = {
      slider: this.querySelector(".swiper"),
      pagination: this.querySelector(".swiper-pagination")
    };
  }
  connectedCallback() {
    this.initSlider();
  }
  initSlider() {
    if (!this.DOM.slider) return;
    new Swiper(this.DOM.slider, {
      loop: true,
      slidesPerView: 1,
      speed: 1e3,
      effect: "fade",
      fadeEffect: {
        crossFade: false
      },
      modules: [EffectFade, Pagination],
      pagination: {
        el: this.DOM.pagination,
        clickable: true
      }
    });
  }
}
window.customElements.define("c-image-slider", ImageSliderComponent);
